import ChannelSelectEditor from './view';

export default ChannelSelectEditor;
